var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.916626 8.00002C0.916626 8.00002 3.58329 2.66669 8.24996 2.66669C12.9166 2.66669 15.5833 8.00002 15.5833 8.00002C15.5833 8.00002 12.9166 13.3334 8.24996 13.3334C3.58329 13.3334 0.916626 8.00002 0.916626 8.00002Z",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24996 10C9.35453 10 10.25 9.10459 10.25 8.00002C10.25 6.89545 9.35453 6.00002 8.24996 6.00002C7.14539 6.00002 6.24996 6.89545 6.24996 8.00002C6.24996 9.10459 7.14539 10 8.24996 10Z",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.fef4026acc5272a63623c5ae3c5e2d86.svg";
export { ForwardRef as ReactComponent };